module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/index-38.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/faq/index.md
// module id = 116
// module chunks = 2